import { UserProfileInterface } from "./interfaces/UserProfileInterface";
import { getProfileColor } from "../../common/ProfileColor";
import { getImageUrlByBackend } from "@api/helpers/url/imageUrl";

export class UserProfile implements UserProfileInterface {
    id = '';
    lastName = '';
    firstName = '';
    middleName = '';
    position = undefined;
    company = undefined;
    groupIds = undefined;
    photoFileId: string | undefined = undefined;
    email = '';
    phoneNumber = '';
    userId: number | undefined = undefined;
    biography = '';
    additionalParameters: any = {};
    updatedAt?: string | undefined;
    tagsIds: string[] | null = null;
    interestingTagIds: string[] | null = null;
    [key: string]: any;

    constructor(data: UserProfileInterface) {
        const additionalParameters: any = {};
        let key: keyof typeof data;
        for (key in data) {
          if(!(key in new UserProfile({}))) {
              additionalParameters[key] = data[key];
          }
        }

        Object.assign(this, {
            id: data.id ? data.id : '',
            lastName: data.lastName ? data.lastName : '',
            firstName: data.firstName ? data.firstName : '',
            middleName: data.middleName ? data.middleName : '',
            position: data.position ? data.position : undefined,
            company: data.company ? data.company : undefined,
            groupIds: data.groupIds ? data.groupIds : undefined,
            photoFileId: data.photoFileId ? data.photoFileId : undefined,
            email: data.email ? data.email : '',
            phoneNumber: data.phoneNumber ? data.phoneNumber : '',
            userId: data.userId ? data.userId : undefined,
            biography: data.biography ?? '',
            updatedAt: data.updatedAt ? data.updatedAt : undefined,
            tagsIds: data.tagsIds ? data.tagsIds : [],
            interestingTagIds: data.interestingTagIds ? data.interestingTagIds : [],

            ...additionalParameters
        });
    }

    get initials(): string {
        const firstName = this.firstName && this.firstName[0],
            lastName = this.lastName && this.lastName[0];
        return [(firstName || ''), (lastName || '')].filter(item => item).join('')
    }

    get lastNameWithInitials(): string {
        const firstName = this.firstName && this.firstName[0]+ '.',
            middleName = this.middleName && this.middleName[0] + '.';
        return `${this.lastName || ''} ${[(firstName || ''), (middleName || '')].filter(item => item).join(' ')}`.trim();
    }

    get fullName(): string {
        return [this.firstName, this.lastName].filter(item => item).join(' ');
    }

    get job(): string {
        return [this.company, this.position].filter(item => item).join(', ');
    }

    profilePhotoLink(backend: string, width = 88): string {
        return getImageUrlByBackend(backend, this.photoFileId, width);
    }

    get profileColor(): string {
        const id = (this as any).profileId || this.id || '';
        return getProfileColor(id);
    }

    getField(fieldName: string) {
        fieldName = fieldName[0].toLowerCase() + fieldName.slice(1);
        return this[fieldName] || this.additionalParameters[fieldName] || "";
    }


    setFirstEntranceStatus(value = false) {
        this.firstEntranceStatus = value;
    }

    static sanitizeFieldName(fieldName: any) {
        return fieldName[0].toLowerCase() + fieldName.slice(1);
    }
}

export const PROFILE_FIELDS_BASIC = ['id', 'userId', 'lastName', 'firstName', 'company', 'position', 'photoFileId'];
export const PROFILE_FIELD_WITH_TAGS = [...PROFILE_FIELDS_BASIC, ...['biography', 'tagsIds', 'interestingTagIds']];
